import {BrowserRouter, Route, Routes} from 'react-router-dom'
import * as Page from 'pages'
import {Layout} from 'layouts/Layout'
import {AuthRoute} from 'routing/AuthRoute'
import {PrivateRoute} from 'routing/PrivateRoute'
import {AppContextProvider} from 'context/AppContext'
import {ModalContextProvider} from 'context/ModalContext'

export const Routing = () => {
  return (
    <BrowserRouter>
      <AppContextProvider>
        <ModalContextProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Page.CouponCenter />} />
              <Route element={<AuthRoute to="/my-store" />}>
                <Route path="/login" element={<Page.SignIn />} />
                <Route path="/register" element={<Page.SignUp />} />
                <Route
                  path="auth/set-password"
                  element={<Page.NewPassword />}
                />
                <Route
                  path="auth/verify-email"
                  element={<Page.VerifyEmail />}
                />
                <Route
                  path="/auth/password-reminder"
                  element={<Page.PasswordReminder />}
                />
              </Route>
              <Route element={<PrivateRoute />}>
                <Route path="/my-store" element={<Page.StoreAdd />} />
                <Route path="/coupons" element={<Page.Coupons />} />
                <Route path="/coupons/:couponId" element={<Page.CouponAdd />} />
                <Route path="/coupons/add" element={<Page.CouponAdd />} />
                <Route path="/payment" element={<Page.Payment />} />
                <Route path="/logout" element={<Page.Logout />} />
              </Route>
            </Route>
          </Routes>
        </ModalContextProvider>
      </AppContextProvider>
    </BrowserRouter>
  )
}
